import { PROJECT_VARIANTS } from '../../constants';
import * as genieGoActions from '../../redux/genie-go/genieGoActions';
import * as consumerGenieGoActions from '../../redux/consumer/genie-go/consumerGenieGoActions';
import { uploadFile } from '../../redux/scout/scoutActions';

const consumerValuesArgs = (args) => args.values;

const genieGoActionsMapping = {
  getData: {
    [PROJECT_VARIANTS.ADMIN]: genieGoActions.getGenieGoData,
  },
  predictResponse: {
    [PROJECT_VARIANTS.ADMIN]: genieGoActions.predictGenieGoResponse,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieGoActions.predictConsumerGenieGoResponse,
    argsTransformer: (args, projectVariant) =>
      projectVariant === PROJECT_VARIANTS.CONSUMER ? consumerValuesArgs(args) : args,
  },
  generateMessages: {
    [PROJECT_VARIANTS.ADMIN]: genieGoActions.generateGenieGoMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieGoActions.generateConsumerGenieGoMessages,
  },
  reply: {
    [PROJECT_VARIANTS.ADMIN]: genieGoActions.replyGenieGo,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieGoActions.replyConsumerGenieGo,
  },
  resetSession: {
    [PROJECT_VARIANTS.ADMIN]: genieGoActions.resetSession,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieGoActions.resetGenieGoSession,
  },
  uploadFile: {
    [PROJECT_VARIANTS.ADMIN]: uploadFile,
    [PROJECT_VARIANTS.CONSUMER]: uploadFile,
  },
};

export default genieGoActionsMapping;
